import React from 'react'
import Wizard from '../../components/Leads/modal/ModalBody/LeadWizard'


const LeadConvertPage = () => {
  return (
    <Wizard />
  )
}

export default LeadConvertPage
